(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-offer-popup"]) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const trigger = root.querySelector('.accio-offer__trigger');
      const dialog = root.querySelector('dialog');
      const close = root.querySelector('.accio-offer__close');
      const form = root.querySelector('form');
      const phone = root.querySelector('input[type="tel"]');
      const status = root.querySelector('[role="status"]');
      const initialStatus = status.textContent;
      const format = (digits) => {
        const value = digits.slice(0, 10);
        if (value.length < 4) return value;
        if (value.length < 7) return `(${value.slice(0, 3)}) ${value.slice(3)}`;
        return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
      };
      trigger.addEventListener('click', () => { dialog.showModal(); trigger.setAttribute('aria-expanded', 'true'); });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => trigger.setAttribute('aria-expanded', 'false'));
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      phone.addEventListener('input', () => {
        phone.value = format(phone.value.replace(/\D/g, ''));
        const valid = phone.value.replace(/\D/g, '').length === 10;
        phone.setCustomValidity(valid || phone.value.length === 0 ? '' : 'Enter a 10-digit US phone number.');
        status.textContent = valid ? 'Valid phone format. Integration is still required; this preview will not submit or store it.' : initialStatus;
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        phone.reportValidity();
        status.textContent = 'Submission is disabled until a storefront-safe SMS consent integration is connected.';
      });
    };
    document.querySelectorAll('[data-accio-offer]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-accio-offer]').forEach(initialize));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accio-radio-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-radio-track]');
      const move = (direction) => track?.scrollBy({ left: direction * Math.max(track.clientWidth * 0.82, 280), behavior: 'smooth' });
      root.querySelector('[data-radio-previous]')?.addEventListener('click', () => move(-1));
      root.querySelector('[data-radio-next]')?.addEventListener('click', () => move(1));
    };
    document.querySelectorAll('[data-accio-radio-slider]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-accio-radio-slider]').forEach(initialize));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accio-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const slides = Array.from(root.querySelectorAll('[data-slide-index]'));
      const dots = Array.from(root.querySelectorAll('[data-slide-dot]'));
      if (slides.length < 2) return;
      let current = 0;
      let timer;
      const select = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, dotIndex) => dot.setAttribute('aria-selected', String(dotIndex === current)));
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => select(current + 1), Number(root.dataset.delay) || 6000);
        }
      };
      root.querySelector('[data-slide-previous]')?.addEventListener('click', () => { select(current - 1); start(); });
      root.querySelector('[data-slide-next]')?.addEventListener('click', () => { select(current + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { select(Number(dot.dataset.slideDot)); start(); }));
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      start();
    };
    document.querySelectorAll('[data-accio-slideshow]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-accio-slideshow]').forEach(initialize));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isaid-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:cart:lines-update',async event=>{
    try {
      const result=await event.promise;
      const count=result?.cart?.totalQuantity??result?.detail?.itemCount;
      if(typeof count==='number')document.querySelectorAll('[data-isaid-cart-count]').forEach(e=>e.textContent=count);
    } catch(error) { if(error?.name!=='AbortError')console.warn('Isaid cart count could not refresh',error); }
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('[data-isaid-header] details[open]').forEach(d=>d.open=false);});
  const positionMenu=details=>{if(!details.open)return;const summary=details.querySelector('summary');const rect=summary.getBoundingClientRect();details.style.setProperty('--isaid-menu-top',rect.bottom+'px');details.style.setProperty('--isaid-menu-left',Math.max(8,Math.min(rect.left,window.innerWidth-208))+'px');};
  document.addEventListener('toggle',event=>{if(event.target.matches?.('.isaid-header__compact-nav details'))positionMenu(event.target);},true);
  window.addEventListener('resize',()=>document.querySelectorAll('.isaid-header__compact-nav details[open]').forEach(positionMenu));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isaid-offer-step"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const update=()=>document.querySelectorAll('.isaid-offer-step shopify-forms-embed').forEach(host=>{
      const root=host.shadowRoot;if(!root||root.querySelector('[data-isaid-inline-style]'))return;
      const style=document.createElement('style');style.dataset.isaidInlineStyle='';style.textContent=':host{font-family:Poppins,sans-serif!important}h2{font-family:Poppins,sans-serif!important;font-size:25px!important;color:#fff!important}[data-testid="btn-form-submit"]{background:#ed3338!important;color:#fff!important;min-height:50px!important}';root.append(style);
    });update();let count=0;const timer=setInterval(()=>{update();if(++count>=30)clearInterval(timer);},500);document.addEventListener('shopify:section:unload',()=>clearInterval(timer),{once:true});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isaid-offer-style"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = () => {
      const settings = document.querySelector('[data-isaid-forms-style]');
      if (!settings) return;
      const css = settings.querySelector('template').content.textContent;
      const formId = settings.dataset.formId;
      const update = () => {
        document.querySelectorAll('shopify-forms-embed').forEach((host) => {
          if (formId && host.id !== 'app-embed-container-' + formId) return;
          const shadow = host.shadowRoot;
          if (!shadow) return;
          let style = shadow.querySelector('[data-isaid-offer-style]');
          if (!style) {
            style = document.createElement('style');
            style.dataset.isaidOfferStyle = '';
            shadow.append(style);
          }
          if (style.textContent !== css) style.textContent = css;
        });
      };
      update();
      const observer = new MutationObserver(update);
      observer.observe(document.body, { childList: true, subtree: true });
      let attempts = 0;
      const timer = setInterval(() => {
        update();
        attempts += 1;
        if (attempts >= 30) clearInterval(timer);
      }, 1000);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(settings)) return;
        clearInterval(timer);
        observer.disconnect();
      });
    };
    setup();
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('[data-isaid-forms-style]')) setup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isaid-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('isaid-product-tabs'))customElements.define('isaid-product-tabs',class extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;const tabs=[...this.querySelectorAll('[role=tab]')];const panels=[...this.querySelectorAll('[role=tabpanel]')];const select=(i,focus=false)=>{tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(n===i));t.tabIndex=n===i?0:-1;panels[n].hidden=n!==i;});if(focus)tabs[i].focus();};tabs.forEach((t,i)=>{t.addEventListener('click',()=>select(i));t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();select(n,true);});});}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
